// função para pegar data atualizada
function getHours() {
  const currentDate = new Date();
  const hours = {
    hours: currentDate.getHours() < 10 ? `0${currentDate.getHours()}` : `${currentDate.getHours()}`,
    minutes: currentDate.getMinutes() < 10 ? `0${currentDate.getMinutes()}` : `${currentDate.getMinutes()}`,
    seconds: currentDate.getSeconds(),
  };
  return hours;
}

// const _hours = {
//     hours: _currentDate.getHours() < 10 ? `0${_currentDate.getHours()}` : `${_currentDate.getHours()}`,
//     minutes: _currentDate.getMinutes() < 10 ? `0${_currentDate.getMinutes()}` : `${_currentDate.getMinutes()}`,
//     seconds: _currentDate.getSeconds()
// }
function getDate(num = 0) {
  const _currentDate = new Date();
  const _date = {
    day: _currentDate.getDate() < 10 ? `0${_currentDate.getDate() + num}` : _currentDate.getDate() + num,
    month: checkMonth(_currentDate.getMonth()),
    year: _currentDate.getFullYear(),
  };
  return _date;
}

function checkMonth(mes: number) {
  if (mes < 9) return `0${mes + 1}`;
  if (mes >= 9) return mes + 1;
}

const dateFromInitial: string = `${getDate().year}/${getDate().month}/01`;
const hoursToInitial: string = currentHours();
const dateToInitial: string = `${getDate().year}/${getDate().month}/${getDate().day}`;
const dateMonthAndYear: string = `${getDate().year}-${getDate().month}`;

function _formatDate(date: string, config?: any) {
  if (config?.length) return date.replaceAll(config[0], config[1]);
  return date?.replaceAll("/", "-");
}

function splitFormartDate(date: string, config: string = "-") {
  return date.split(config);
}

function currentHours() {
  const _hours = getHours();
  const hours = _hours.hours;
  const minutes = _hours.minutes;
  return `${hours}:${minutes}`;
}

function currentDate(num = 0) {
  return `${getDate().year}/${getDate().month}/${getDate(num).day}`;
}

function convertDate(date: string) {
  // example date: 2021-08-21
  const year = date?.slice(0, 4);
  const month = date?.slice(5, 7);
  const day = date?.slice(8, 10);

  return `${day}/${month}/${year}`;
}

function convertHoursIntoSeconds(hora: any) {
  const hour = hora;
  if (!hour) return 0;
  const arrayTime = hour.split(":");
  const totalMinutes = Number(arrayTime[0]) * 3600 + Number(arrayTime[1]) * 60;
  return totalMinutes;
}

function convertSecondsToHoursAndMinutes(secondsTotal: number) {
  const total = secondsTotal;
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total - hours * 3600) / 60);
  const seconds = Math.floor(total % 60);
  const result = `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
  return result;
}

export {
  convertDate,
  _formatDate,
  splitFormartDate,
  currentHours,
  dateFromInitial,
  hoursToInitial,
  dateToInitial,
  dateMonthAndYear,
  convertHoursIntoSeconds,
  currentDate,
  convertSecondsToHoursAndMinutes,
};
